import React, {Component} from 'react'
import Modal from '../SharedComponents/Modal'
import SQLRulesModalBody from "./SQLRulesModalBody";

class SQLRulesModal extends Component {
    render() {
        return (
            <Modal name="sqlRulesModal"
                   header={null}
                   body={<SQLRulesModalBody/>}
                   size="medium"
            />
        )
    }
}


export default SQLRulesModal